exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3uEl9z7TSXafrQQfuRQUT7{fill:\"[theme:neutralPrimary, default:#333333]\"}._24PZ6mkmhO-7XeejMnz33B{cursor:pointer!important}.piwJQ0uwjYBMCaABAPuSK{width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"icon": "_3uEl9z7TSXafrQQfuRQUT7",
	"card": "_24PZ6mkmhO-7XeejMnz33B",
	"image": "piwJQ0uwjYBMCaABAPuSK"
};